import FilterDropdown from "./FilterDropdown.component";

export default FilterDropdown;
